<div class="subheader-holder">
  <div class="subheader-content">
    <!-- Submitters  -->
    <ng-container *ngIf="userType === 'reviewer'" >

      <ng-container  *ngIf="bannerType === 'trial'">
        <p class="decription">
          You have 
          <b>  {{ remainingDays }}</b>
          days left on your free trial after which your account will be charged
        </p>
        <p class="decription">
          based on the amount of users you have added. For details on pricing see 
          <a target="_blank" href="https://eyrus.com/pricing-axon" class="underlined"> here </a>
        </p>
      </ng-container>

      <ng-container  *ngIf="bannerType === 'locked'">
        <p class="decription">
          Oh no! It looks like we weren't able to process your latest payment. You have
          <b>  {{ remainingDays }}</b>
          days
        </p>
        <p class="description">
          until the account is locked and you are not able to access past activity.
        </p>
        <p class="description">
          Please 
          <a class="underlined" href="https://eyrus.com/contact/" target="_blank"> contact us </a>
          to update your payment method or if you have any questions.
        </p>
      </ng-container>
    </ng-container>

    <!-- Reviewers -->
    <ng-container *ngIf="userType === 'submitter'" >

      <ng-container  *ngIf="bannerType === 'trial'">
        <p class="decription">
          The account that you are on has 
          <a class="underlined">  {{ remainingDays }}</a>
          days left in its free trial!
        </p>
      </ng-container>

      <ng-container  *ngIf="bannerType === 'locked'">
        <p class="decription">
            Oh no! It looks like there's an issue with the account. You have
          <b>  {{ remainingDays }}</b>
          days
        </p>
        <p class="description">
          until this account is locked and you will not be able to access your past activity.
        </p>
        <p class="description">
          Please talk to your account's administrator to update billing information.
        </p>
      </ng-container>
    </ng-container>
  </div>

  <div class="subheader-close-icon" (click)="closeAction()" *ngIf="showClose">
    <span>
      <i class="ae ae-multiply-bolt"></i>
    </span>
  </div>
</div>